import { openPanel, updatePanel } from "../slideout-panel/slideout-panel";
import { fetchText } from '../fetch-helper/fetch-helper';
import { asyncAddExtenalScript } from "../utility-functions/async-external-assets";

declare const Appointedd: any;

const SDK_URL = 'https://booking-tools-sdk.appointedd.com/appointedd-booking-tools-sdk-v1.js';
const ALL_SERVICES_WIDGET_ID = '698b332d2becbfc2d2bb7b44';
const CUSTOM_MADE_WIDGET_ID = '698b351b5cfee14ffd2b6665';

export const appointedd = (button = null) => {
  if (button) {
    const url = button.getAttribute('href');
    const store = button.dataset.store;
    const draft = button.dataset.draft;

    openPanel('Appointedd', fetchAppointments(url, store, draft));
  } else {
    const iteration = document.querySelectorAll<HTMLElement>(`[data-appointedd="button"]`);
    iteration.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const url = button.getAttribute('href');
        const store = button.dataset.store;
        const draft = button.dataset.draft;

        openPanel('Appointedd', fetchAppointments(url, store, draft));
      });
    });
  }
}

const fetchAppointments = (url: string, store: string, draft: string) => {
  console.info('[Appointedd] Opening slideout', {
    bookingUrl: url,
    draftOrderId: draft,
  });

  const data = fetchText(url, null);

  data.then(data => {
    updatePanel('Appointedd', data);
    asyncAddExtenalScript(SDK_URL).then(() => {
      render(draft, url, store);
    });
  });
}

const getWidgetId = (bookingUrl: string, draft: string): string => {
  const params = new URL(bookingUrl, window.location.origin).searchParams;
  const isCustomMade =
    window.location.pathname.includes('/custom-made') ||
    Boolean(draft) ||
    params.has('draft') ||
    params.has('orderid') ||
    params.has('isTailorMe');

  return isCustomMade ? CUSTOM_MADE_WIDGET_ID : ALL_SERVICES_WIDGET_ID;
};

export const render = (draftOrderId: string, bookingUrl = '', storeId = ''): void => {
  const organisation = document.querySelector('[name="appointeddOrganisation"]') as HTMLInputElement;

  const widgetLoaded = setInterval(() => {
    if (typeof Appointedd?.renderWidget === 'function') {
      clearInterval(widgetLoaded);

      const widgetId = getWidgetId(bookingUrl, draftOrderId);
      const organisationId = organisation?.value;
      const containerId = 'appointeddContainer';

      Appointedd.renderWidget(containerId, {
        widgetId,
        enableLanguageSelector: false,
        organisationId,
      });

      const widgetFrame = document.querySelector(`#${containerId} iframe`) as HTMLIFrameElement;

      console.info('[Appointedd] Dynamic slideout render', {
        widgetId,
        organisationId,
        containerId,
        AppointeddUrl: widgetFrame?.src || null,
      });
    }
  }, 100);
}
